export enum RoutePath {
  Base = '/',
  Login = 'login',
  EVSEDetailsBase = 'evse',
  EVSEDetails = 'evse/:cpid',
  All = '*',
}
